import { COLOR_VISION_EVENT } from '@shopify/polaris-viz-core';

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
function getDataSetItem(dataset, name) {
  return dataset[`${COLOR_VISION_EVENT.camelCaseName}${capitalize(name)}`];
}
function getEventName(id, type) {
  return `${id}:${COLOR_VISION_EVENT.name}:${type}`;
}

export { capitalize, getDataSetItem, getEventName };
